
import ogPagesMixins from '@/mixins/ogPagesMixins'

const url = '/suppliers/vacancys'

const LIMIT = 10

// Настройки SEO полей head
const SEO = {
  TITLE: 'Вакансии | Мегасреда',
  DESCRIPTION: 'Свежие вакансии от компаний',
  H1: 'Самые свежие и актуальные вакансии',
  IMAGE: {
    url: 'https://megasreda.ru/img/products/vacancys_ogg.jpg',
    urlVk: 'https://megasreda.ru/img/products/vacancys_ogg-vk.jpg',
    urlTw: 'https://megasreda.ru/img/products/vacancys_ogg.jpg',
    type: 'image/jpeg',
    width: 1200,
    height: 630,
  },
}
export default {
  mixins: [ogPagesMixins],
  scrollToTop: true,
  async asyncData({ $axios }) {
    const { companys } = await $axios.$get(url, {
      params: { limit: LIMIT },
    })
    return {
      companys,
    }
  },
  data() {
    return {
      products: [],
      productsCount: 0,
      page: this.$route.query?.page ? this.$route.query.page : 1,
    }
  },

  async fetch() {
    await this.fetchProducts()
  },
  computed: {
    seoTitle() {
      return SEO.TITLE
    },
    seoDescription() {
      return SEO.DESCRIPTION
    },
    seoH1() {
      return SEO.H1
    },
    seoImage() {
      return SEO.IMAGE
    },
    pageCount() {
      return Math.ceil(this.productsCount / LIMIT)
    },
    productsOffset() {
      return (this.page - 1) * LIMIT
    },
  },
  watch: {
    $route() {
      if (!this.$route.query?.page) {
        this.page = 1
        this.products = []
        this.$router.push({
          query: {},
        })
        this.fetchProducts()
      }
    },
  },

  methods: {
    updateVacancy() {
      this.products = []
      this.fetchProducts()
    },
    async fetchProducts() {
      const { products, countAllPublishedProducts } = await this.$axios.$get(
        'advertisements/vacancys/new',
        {
          params: {
            limit: LIMIT,
            offset: this.productsOffset,
          },
        }
      )

      this.productsCount = countAllPublishedProducts
      this.products = this.products?.length
        ? this.products.concat(products)
        : products
    },

    paginateClick(page) {
      this.products = []
      if (page === 1) {
        this.$router.push({
          query: {},
        })
      } else {
        this.$router.push({
          query: {
            ...this.$route.query,
            page: this.page,
          },
        })
        this.fetchProducts()
      }
      this.$scrollTo('body')
    },
    loadMore() {
      this.page++
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.page,
        },
      })
      this.fetchProducts()
    },
  },
}
